export const additionalServicesEnum = {
  RENT_PROTECTION: 'RentProtection',
  RENTAL_COVER: 'RentalCover',
  RENTAL_COVER_FORMATTED_NAME: 'Rentalcover',
  PRICE_LOCK: 'PriceLock',
  RP_FORMATTED_NAME: 'Rent Protection'
}
